import { useCallback, useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { PlanType } from '~/common/types';
import store from '~/store';

export const useIsSandboxOrg = () => {
  const { currentOrganizationDetail } = useSnapshot(store);

  const isSandboxOrg = useMemo(() => {
    if (!currentOrganizationDetail.isLoading && currentOrganizationDetail.plan === PlanType.Sandbox) {
      return true;
    }

    return false;
  }, [currentOrganizationDetail]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  return useCallback(() => isSandboxOrg, []);
};
